export enum MOVE_TYPE {
  BRADESCO_CREATION = 'bradesco:creation',
  BRADESCO_REMOVAL = 'bradesco:removal',
  BRADESCO_UPDATE = 'bradesco:update',
  DEFAULT_CREATION = 'default:creation',
  DEFAULT_REMOVAL = 'default:removal',
  DEFAULT_UPDATE = 'default:update',
  DEFAULT_CREATION_STONE = 'default:creation:creation-stone',
  CNU_CREATION = 'cnu:creation',
  CNU_REMOVAL = 'cnu:removal',
  CNU_UPDATE = 'cnu:update',
  DEFAULT_CREATION_HEALTH_CADMUS = 'default:creation:creation-health-cadmus',
  DEFAULT_CREATION_DENTAL_CADMUS = 'default:creation:creation-dental-cadmus',
  DEFAULT_CREATION_INSPER = 'default:creation:creation-insper',
  INDICATION_CREATION = 'indication:creation'
}

export enum MOVE_STATUS {
  NOT_INITIALIZED = 'not-initialized',
  IN_PROCESS = 'in-process',
  PROCESS_ERROR = 'process-error',
  PROCESS_PROVIDER_ERROR = 'process-provider-error',
  PROCESSED = 'processed',
  REJECTED = 'rejected',
}

export enum MOVE_LIST_FILTERS {
  SEARCH = 'search',
  TYPE = 'type',
  DATE_MIN = 'createdAtMin',
}

export enum MOVE_LIST_COLUMNS {
  NAME = 'name',
  USER_NAME = 'user_name',
  TYPE = 'type',
  PROVIDER = 'provider',
  STATUS = 'status',
  UPDATED_AT = 'updated_at',
}

export enum MOVE_LIST_ACTIONS {
  DETAILS = 'details',
  DOWNLOAD = 'download',
}

export enum MOVE_ROW_BENEFICIARY_STATUS {
  NOT_INITIALIZED = 'not-initialized',
  VALIDATED = 'validated',
  VALIDATED_WITH_ERROR = 'validated-with-error',
  PROCESSED = 'processed',
  PROCESSED_WITH_ERROR = 'processed-with-error',
  UNKNOWN = 'unknown',
}

export enum MOVE_ACTION {
  CREATION = 'creation',
  REMOVAL = 'removal',
  UPDATE = 'update',
}

// Status do processo da solicitação de movimentação via API da Operadora
export enum MOVE_ROW_PROCESS_STATUS {
  PENDING = 'pending',
  PROCESSING = 'processing',
  WAITING_HEALTH_CARD = 'waiting_health_card',
  PROCESSING_WAITING_HEALTH_CARD = 'processing_waiting_health_card',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  ERROR = 'error',
}
